@use "../../../styles/breakpoint.module.scss" as *;

.row {
    --space-for-flanks: 300px;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-inline: calc(
        var(--space-for-flanks) + var(--labui-container-margin)
    );
    text-align: center;
    min-height: 70px;
    color: var(--gray-900);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;

    @media ($below-mobile) {
        --space-for-flanks: 90px;
    }
}

.flank {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.left {
    composes: flank;
    left: var(--labui-container-margin);
}

.right {
    composes: flank;
    right: var(--labui-container-margin);
}

.detailsLink {
    font: var(--font-text-link-14);
    text-decoration: underline;
}
